import { render, staticRenderFns } from "./ReplyBottomPanel.vue?vue&type=template&id=246b7b9e&scoped=true&"
import script from "./ReplyBottomPanel.vue?vue&type=script&lang=js&"
export * from "./ReplyBottomPanel.vue?vue&type=script&lang=js&"
import style0 from "./ReplyBottomPanel.vue?vue&type=style&index=0&id=246b7b9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246b7b9e",
  null
  
)

export default component.exports